module.exports = __webpack_public_path__ + "static/media/cq_richieste_scadute b.3f0eb566.svg";